export const BASE_EMAIL_TODO = 'todo@todo.com'
